import axios, { baseUrl } from './axios';
import queryString from 'query-string';

export default {
  loadPackageList: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    if (options.organisationId) {
      const result = await axios.get(
        `${baseUrl}/scheduler/mob/organisations/${
          options.organisationId
        }/packages${params ? `?${params}` : ''}`,
      );
      return result.data;
    }
  },

  loadPackageDetail: async (options = {}) => {
    let params = '';
    if (options.filter) {
      params = queryString.stringify(Object.assign(options.filter));
    }

    const result = await axios.get(
      `${baseUrl}/scheduler/mob/organisations/${
        options.organisationId
      }/package/${options.packageId}${params ? `?${params}` : ''}`,
    );
    return result.data;
  },

  createPackage: async options => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );

    const result = await axios.post(
      `${baseUrl}/scheduler/mob/organisations/${
        options.organisationId
      }/packages${params ? `?${params}` : ''}`,
      options,
    );
    return result.data;
  },

  updatePackage: async data => {
    const result = await axios.put(
      `${baseUrl}/scheduler/mob/organisations/${data.organisationId}/packages`,
      data,
    );
    return result.data;
  },

  deletePackage: async data => {
    const result = await axios.delete(
      `${baseUrl}/scheduler/mob/organisations/${data.organisationId}/package/${
        data.id
      }`,
      data,
    );
    return result.data;
  },

  loadAssessmentList: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    const result = await axios.get(
      `${baseUrl}/scheduler/mob/assessment/listAssessment${
        params ? `?${params}` : ''
      }`,
    );
    return result.data;
  },

  loadAssessmentGroup: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    const result = await axios.get(
      `${baseUrl}/scheduler/mob/assessment/group_assessment${
        params ? `?${params}` : ''
      }`,
    );
    return result.data;
  },
};
